// extracted by mini-css-extract-plugin
module.exports = {"screen":"SiftingLogo_screen__Q9ND0"};